module.exports = __webpack_public_path__ + "static/media/Braum.6929020f.png";